import { useTranslate } from "@similarweb/i18n-provider";

import { swSettings } from "app/common/services/swSettings";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import QuotaTag from "../../components/QuotaTag";
import { DataCreditsHighUsageTooltip } from "../../components/QuotaTag/tooltipContent/DataCreditsHighUsageTooltip";
import { DataCreditsNoCreditsTooltip } from "../../components/QuotaTag/tooltipContent/DataCreditsNoCreditsTooltip";
import { useExportQuota } from "../../hooks/useExportQuota";
import { getQuotaTagCreditsVisualState } from "../../utils/getQuotaTagCreditsVisualState";
import { quotaKeys } from "../../utils/i18n";

const DataCreditsIndicatorContainer = () => {
    const { translate } = useTranslate();
    const { isLoading, data } = useExportQuota();

    const { isDataCreditsEnabled } = salesSettingsHelper;

    if (!isDataCreditsEnabled || isLoading || !data) {
        return null;
    }

    const isNoTouchUser = isNoTouch(swSettings);
    const isAdminUser = salesSettingsHelper.isAdmin();
    const creditsVisualState = getQuotaTagCreditsVisualState(data.remaining, data.used, data.total);

    const buttonI18nKey = quotaKeys.dataCreditsIndicatorLabel({
        count: data.remaining,
    });

    const title = translate(buttonI18nKey.key, buttonI18nKey.replacements);

    const tooltipContent =
        creditsVisualState === "highUsage" ? (
            <DataCreditsHighUsageTooltip />
        ) : creditsVisualState === "noCredits" ? (
            <DataCreditsNoCreditsTooltip
                isNoTouchUser={isNoTouchUser}
                isAdminUser={isAdminUser}
                remaining={data.remaining}
            />
        ) : undefined;

    return (
        <QuotaTag
            extendedCredits
            creditsVisualState={creditsVisualState}
            tooltipContent={tooltipContent}
            creditsDepleted={data.remaining <= 0}
            iconName="spend"
            size="sm"
            title={title}
            type="light"
            dataAutomation="quota-data-credits-indicator"
        />
    );
};

export default DataCreditsIndicatorContainer;
